import type { SplitOrderInvoicesDetailLineItem } from './split_order_invoices_detail_types';

export default function splitOrderInvoicesDetailApiToVM(apiResult: any): SplitOrderInvoicesDetailLineItem[] {
    const items: any[] = Array.isArray(apiResult) ? apiResult : [];

    items.forEach(item => {
        item.Overallocated = item.Overallocated === true ? 'YES' : 'NO';
        item.NdcOptimized = item.NdcOptimized === true ? 'YES' : 'NO';
        item.IsRebate = item.IsRebate === true ? 'YES' : 'NO';
        item.BackingTxt = !!item.LineId ? 'YES' : 'NO';
    });

    return items;
}
